import Vue from 'vue'
import App from './App'
import router from './router'
import vuetify from '@/plugins/vuetify' // path to vuetify expo
import Vuex from "vuex";
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

// 缓存
import { store } from "@/store/store";
// JS初始化数据
import init from '@/store/init.js';

// CSS
import '../static/css/common.css'
import '../static/css/margin.css'
import '../static/css/font.css'
import '../static/css/fontSize.css'
import '../static/scss/common.scss'

import config from '@/config/index.js'
import tools from '../static/js/tools.js'


//echarts
import * as echarts from 'echarts'

Vue.prototype.$echarts = echarts
Vue.prototype.$config = config
Vue.prototype.$tools = tools

Vue.config.productionTip = false

Vue.use(Vuex);
Vue.use(init);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  vuetify,
  created: function() {
    this.init()
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js